(function () {
  function getSignature(root) {
    var enable = root.dataset.enableCarousel === "true";
    var loopSetting = root.dataset.loopCarousel === "true";
    var dotsSetting = root.dataset.showIndicators === "true";
    var slideCount = root.querySelectorAll(".swiper-slide").length;
    return [enable, loopSetting, dotsSetting, slideCount].join("|");
  }

  function destroyInstance(root) {
    var instance = root.__productCardSwiper;
    if (!instance || typeof instance.destroy !== "function") return;

    try {
      instance.destroy(true, true);
    } catch (e) {}

    root.__productCardSwiper = null;
  }

  function initOne(root) {
    if (!root) return;
    if (!window.Swiper) return;

    var enable = root.dataset.enableCarousel === "true";
    var loopSetting = root.dataset.loopCarousel === "true";
    var dotsSetting = root.dataset.showIndicators === "true";
    var slides = root.querySelectorAll(".swiper-slide");
    var signature = getSignature(root);
    var existing = root.__productCardSwiper;

    if (!enable || slides.length <= 1) {
      destroyInstance(root);
      root.dataset.swiperSignature = signature;
      return;
    }

    if (existing && root.dataset.swiperSignature === signature) {
      if (typeof existing.update === "function") {
        try {
          existing.update();
        } catch (e) {}
      }
      return;
    }

    destroyInstance(root);

    var canLoop = loopSetting && slides.length > 1;
    var paginationEl = root.querySelector(".swiper-pagination");
    var instance = new window.Swiper(root, {
      slidesPerView: 1,
      loop: canLoop,
      speed: 250,

      allowTouchMove: true,
      simulateTouch: true,
      touchStartPreventDefault: false,

      pagination: dotsSetting && paginationEl
        ? { el: paginationEl, clickable: true }
        : undefined,
    });

    root.__productCardSwiper = instance;
    root.dataset.swiperSignature = signature;
  }

  function boot() {
    document.querySelectorAll(".product-card-swiper").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // for dynamic loads (filters, section hydration)
  var rafId = null;
  var mo = new MutationObserver(function () {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = null;
      boot();
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Cleanup observer on page unload to prevent memory leaks
  window.addEventListener('pagehide', function () {
    if (mo) {
      mo.disconnect();
      mo = null;
    }
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }, { once: true });
})();
